import { render, staticRenderFns } from "./reservationClient.vue?vue&type=template&id=3591dcf3"
import script from "./reservationClient.vue?vue&type=script&lang=ts"
export * from "./reservationClient.vue?vue&type=script&lang=ts"
import style0 from "./reservationClient.vue?vue&type=style&index=0&id=3591dcf3&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports